import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Shared desktop empty state component for displaying "No Passports Yet" message.
 * Used across transloading, shunting, growers, and receiver components.
 */
@Component({
  selector: 'app-desktop-empty-state',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="desktop-empty-state">
      <div class="empty-circle">
        <img [src]="iconSrc" class="empty-icon" [alt]="iconAlt">
      </div>
      <div class="empty-text">{{ text }}</div>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 100%;
      min-height: 0;
    }

    .desktop-empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      width: 100%;
      position: relative;
      min-height: 0;
    }

    .empty-circle {
      width: 138px;
      height: 138px;
      border-radius: 50%;
      background-color: #FFFFFF;
      backdrop-filter: blur(4px);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;
    }

    .empty-icon {
      width: 56px;
      height: auto;
    }

    .empty-text {
      font-family: Lato, sans-serif;
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;
      color: #000000;
      text-align: center;
    }
  `]
})
export class DesktopEmptyStateComponent {
  @Input() text: string = 'No Passports Yet';
  @Input() iconSrc: string = '/assets/images/No_Passports_Icon.png';
  @Input() iconAlt: string = 'No passports';
}
